export const animation = {
  duration: {
    standard: '100ms',
    enter: {
      s: '250ms',
      m: '300ms',
      l: '450ms'
    },
    exit: {
      s: '200ms',
      m: '250ms',
      l: '400ms'
    },
    spin: '700ms'
  },
  timingFunction: {
    standard: 'cubic-bezier(0.5, 0, 0.2, 1)',
    enter: {
      m: 'cubic-bezier(0, 0.5, 0.2, 1)'
    },
    exit: {
      m: 'cubic-bezier(0.5, 0, 0.8, 1)'
    }
  }
};
//# sourceMappingURL=animation.js.map